import { motion } from "framer-motion";

interface SectionHeadingProps {
  subtitle?: string;
  title: string;
  description?: string;
  align?: "center" | "left";
}

const SectionHeading = ({ subtitle, title, description, align = "center" }: SectionHeadingProps) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-50px" }}
    transition={{ duration: 0.6 }}
    className={align === "center" ? "text-center mb-16" : "mb-16"}
  >
    {subtitle && (
      <span className="text-gold text-sm font-body font-semibold tracking-[0.2em] uppercase block mb-3">
        {subtitle}
      </span>
    )}
    <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-cream leading-tight">
      {title}
    </h2>
    {align === "center" && <div className="gold-line mt-6" />}
    {align === "left" && <div className="gold-line-left mt-6" />}
    {description && (
      <p className="mt-6 text-muted-foreground max-w-2xl font-body text-base leading-relaxed mx-auto">
        {description}
      </p>
    )}
  </motion.div>
);

export default SectionHeading;
